import PropTypes from 'prop-types';
import React from 'react';

import { Meta } from '$partials/global';
import * as Pages from './union';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const UnionPage = (props) => {
    if (!props.data?.page?.__typename || typeof (Pages[props.data?.page?.__typename]) === 'undefined') {
        return null;
    }

    const Component = Pages[props.data?.page?.__typename];

    return (
        <>
            <Meta
                description={props.data?.page?.searchDescription || props.data?.page?.listingText}
                domain={props.domain}
                image={props.data?.page?.listingImage}
                page={props.data?.page} />
            <Component { ...props } />
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    data: PropTypes.shape({
        page: PropTypes.shape({
            __typename: PropTypes.string.isRequired,
            listingImage: PropTypes.object,
            listingText: PropTypes.string,
            searchDescription: PropTypes.string
        }),
        uri: PropTypes.string,
    }).isRequired,
    domain: PropTypes.string,
    pageComponent: PropTypes.string.isRequired
};

UnionPage.propTypes = propTypes;

export default UnionPage;
